import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import FeedImportsComponent from '@app/components/apps/FeedImport/FeedImport';

export const ViewFeedImport: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Feed Import');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    { path: '/feed-imports', breadcrumbName: 'Feed Importation' },
    { path: `/view-feed-import/${id}`, breadcrumbName: 'View Feed Import' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FeedImportsComponent
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Feed Import`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default ViewFeedImport;
